import moment from "moment";
import 'moment-timezone';
import 'moment/locale/de';

//development
//var BASE_URL = 'https://api-qa.myfitapp.com/integration/';
//var PLAYER_BASE_URL = 'https://qa1-de.myfitapp.de/';

//production
var BASE_URL = 'https://api.myfitapp.com/v1/';
var PLAYER_BASE_URL = 'https://player.myfitapp.com/';

export default class Functions{
    
    enumerateDaysBetweenDates = (startDate, endDate) => {
      var dates = [];
      var currDate = moment(startDate).startOf('day');
      var lastDate = moment(endDate).startOf('day');
      dates.push(currDate.clone().toDate());
      while(currDate.add(1, 'days').diff(lastDate) < 0) {
          dates.push(currDate.clone().toDate());
      }
      return dates;
    }

    createResponseModal = (response, from_day, to_day) => {

      var return_data = {};
      var session_1 = []; // < 12:00 Morning
      var session_2 = []; // 12:00 to < 18:00 Afternoon
      var session_3 = []; // 18:00 to < 24:00 Evening

      var enumeratedDays = this.enumerateDaysBetweenDates(from_day, to_day);
      for (var p = 0; p < enumeratedDays.length; p++) {
          var sDate = moment(enumeratedDays[p]).format('DD-MM-YYYY');
          session_1[sDate] = session_1[sDate] || [];
          session_2[sDate] = session_2[sDate] || [];
          session_3[sDate] = session_3[sDate] || [];
      }

      for (var i = 0; i < response.result.length; i++) {
        var item = response.result[i];
        var start_time = moment.tz(item.start, item.location.timezone).lang('en').format('HH:mm');

        var event_data = {};
        event_data['event_id'] = item.id;
        event_data['date'] = moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY');
        event_data['start_time'] = moment.tz(item.start, item.location.timezone).format('HH:mm');
        event_data['end_time'] = moment.tz(item.end, item.location.timezone).format('HH:mm');
        event_data['event_name'] = item?.typeDetail?.name;
        event_data['location_name'] = item?.location?.name;
        event_data['location_timezone'] = item?.location?.timezone;
        event_data['subLocation_name'] = item?.subLocation?.name;
        event_data['color'] = item?.type?.categories ? item?.type?.categories[0]?.color : '';
        event_data['event_type_image'] = item?.typeDetail?.imageUrl;
        event_data['event_type_description'] = item?.typeDetail?.description;
        event_data['event_status'] = (item.status) ? item.status.id : '';
        event_data['event_status_msg'] = (item.status) ? item.status.msg : '';
        event_data['trainer_name'] = (item.leader) ? item.leader.name : '';
        event_data['level'] = (item.level) ? item.level.name : '';
        event_data['category_name'] = item?.type?.categories ? item?.type?.categories[0]?.name : '';
        event_data['video_btn_label'] = (item.videoContent) ? item.videoContent.linkLabel : '';
        event_data['video_url'] = (item.videoContent) ? item.videoContent.webUrl : '';
        event_data['video_content_id'] = (item.videoContent) ? item.videoContent.contentId : '';
    
        session_1[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')] = session_1[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')] || [];
        session_2[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')] = session_2[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')] || [];
        session_3[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')] = session_3[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')] || [];

        switch (true) {
            case start_time < "12:00":
                session_1[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')].push(event_data);
                break;
            case start_time >= "12:00" && start_time < "18:00":
                session_2[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')].push(event_data);
                break;
            case start_time >= "18:00" && start_time < "24:00":
                session_3[moment.tz(item.start, item.location.timezone).format('DD-MM-YYYY')].push(event_data);
                break;
            default:
        }

        return_data['session_1'] = session_1;
        return_data['session_2'] = session_2;
        return_data['session_3'] = session_3;
      }
      return return_data;
    }

    getUrlParameter = (name) => {
        name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        let results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    getEventsApiUrl = (apiConfig, selectedLocation, selectedCategory, from_day, to_day) => {

        var locations = '';
        if(selectedLocation === ''){
            if(typeof apiConfig.defaultLocation === 'undefined'){
                locations = apiConfig.locations;
            }else{
                locations = apiConfig.defaultLocation;
            }  
        }else{
            locations = selectedLocation;
        }

        // var locations =  selectedLocation === '' ? apiConfig.locations : selectedLocation ;
        var categories =  selectedCategory === '' ? apiConfig.categories : selectedCategory ;
        var subLocations =  apiConfig.subLocations !== '' ? apiConfig.subLocations : '';
        var isWidget = apiConfig.isWidget ? true : false
        var filterString = apiConfig.filterString !== '' ? apiConfig.filterString : '';

        return BASE_URL + 'events/?program=' + apiConfig.program + '&locations=' + locations
            + '&categories='+ categories + '&subLocations=' + subLocations
            + '&from=' + from_day + '&until=' + to_day
            + '&isWidget=' + isWidget + '&filterString=' + filterString
            + '&x-api-key=' + apiConfig.apiKey;
    }

    getLocationsApiUrl = (apiConfig) => {
        return BASE_URL + 'events/locations/'+ apiConfig.program + '/?x-api-key='+ apiConfig.apiKey;
    }

    getCategoriesApiUrl = (apiConfig) => {
        return BASE_URL + 'events/categories/'+ apiConfig.program + '/?x-api-key='+ apiConfig.apiKey;
    }

    getCentersApiUrl = (apiConfig, language) => {
        var obj = new Object();
        obj.countries = "SA"
        obj.language = language
        obj.programExtId = apiConfig.program
        obj.provider = apiConfig.provider
        obj.filterType = "CENTERS"
        obj.clubId = apiConfig.clubId

        let paramsEnc = btoa(JSON.stringify(obj));

        return BASE_URL + 'events/widget/filters/'+ paramsEnc + '/?x-api-key='+ apiConfig.apiKey;
    }

    getActivityGroupApiUrl = (apiConfig, language) => {
        var obj = new Object();
        obj.centers = apiConfig.centers
        obj.language = language
        obj.programExtId = apiConfig.program
        obj.provider = apiConfig.provider
        obj.filterType = "ACTIVITY_GROUPS"
        obj.clubId = apiConfig.clubId

        let paramsEnc = btoa(JSON.stringify(obj));

        return BASE_URL + 'events/widget/filters/'+ paramsEnc + '/?x-api-key='+ apiConfig.apiKey;
    }

    getMagiclineLocationsApiUrl = (apiConfig, language) => {
        var obj = new Object();
        obj.language = language
        obj.programExtId = apiConfig.program
        obj.provider = apiConfig.provider
        obj.filterType = "ORGANISATION_UNIT"
        obj.clubId = apiConfig.clubId

        let paramsEnc = btoa(JSON.stringify(obj));

        return BASE_URL + 'events/widget/filters/'+ paramsEnc + '/?x-api-key='+ apiConfig.apiKey;
    }

    getMagiclineV2ClassTypeApiUrl = (apiConfig, language) => {
        var obj = new Object();
        obj.language = language
        obj.programExtId = apiConfig.program
        obj.provider = apiConfig.provider
        obj.filterType = "CLASS_TYPE"
        obj.clubId = apiConfig.clubId

        let paramsEnc = btoa(JSON.stringify(obj));

        return BASE_URL + 'events/widget/filters/'+ paramsEnc + '/?x-api-key='+ apiConfig.apiKey;
    }

    calculateWidgetColumn = (width, height) => {
        var column = 0;
        if(width > 1300){
            column = 7;
        }else if(width >= 1100 && width <= 1300){
            column = 6;
        }else if(width >= 1008 && width <= 1099){
            column = 5;
        }else if(width >= 915 && width <= 1007){
            column = 4;
        }else if(width >= 900 && width <= 916){
            column = 4;
        }else if(width >= 720 && width <= 783){
            column = 3;
        }else if(width >= 720 && width <= 899){
            column = 4;
        }else if(width >= 540 && width <= 719){
            column = 3;
        }else if(width >= 400 && width <= 539){
            column = 2;
        }else if(width >= 360 && width <= 399){
            column = 2;
        }else if(width <= 359){
            column = 1;
        }
        return column;
    }

    getPlayerBaseUrl = () => {
        return PLAYER_BASE_URL;
    }

    removeParamFromUrl = (key, sourceURL) => {
        var rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    }
}